import { makeStyles } from '@material-ui/core';
import styled from 'styled-components';

export const useStyles = makeStyles(() => ({
	grid: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center'
	}
}));

export const Icon = styled.img`
	height: 60px;
	width: 60px;
`;
